import React, { useState, useEffect } from 'react';
import { getDashboardMembre } from '../services/api';
import { FiDollarSign, FiHash } from 'react-icons/fi';

const formatMoney = (n: number) => new Intl.NumberFormat('fr-FR').format(n) + ' FCFA';

const MesVersements = () => {
  const [versements, setVersements] = useState<any[]>([]);
  const [totalVersements, setTotalVersements] = useState(0);
  const [nbVersements, setNbVersements] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getDashboardMembre().then(r => {
      setVersements(r.data.versements || []);
      setTotalVersements(r.data.totalVersements || 0);
      setNbVersements(r.data.nbVersements || 0);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  if (loading) return <div>Chargement...</div>;

  return (
    <div>
      <h1 className="page-title">Mes versements</h1>

      {/* KPI Cards */}
      <div className="kpi-grid">
        <div className="kpi-card">
          <div className="kpi-icon" style={{ background: '#e3f2fd', color: '#1565c0' }}><FiHash /></div>
          <div className="kpi-info">
            <span className="kpi-value">{nbVersements}</span>
            <span className="kpi-label">Nombre de versements</span>
          </div>
        </div>
        <div className="kpi-card">
          <div className="kpi-icon" style={{ background: '#e8f5e9', color: '#2e7d32' }}><FiDollarSign /></div>
          <div className="kpi-info">
            <span className="kpi-value">{formatMoney(totalVersements)}</span>
            <span className="kpi-label">Total versements</span>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="card">
        <div className="card-header">
          <span>Liste des versements ({nbVersements})</span>
        </div>
        <div className="card-body">
          {versements.length === 0 ? (
            <p style={{ color: '#888', textAlign: 'center', padding: '2rem 0' }}>Aucun versement enregistré</p>
          ) : (
            <div className="table-responsive">
              <table className="data-table">
                <thead>
                  <tr><th>#</th><th>Date</th><th>Type</th><th>Référence</th><th style={{ textAlign: 'right' }}>Montant</th></tr>
                </thead>
                <tbody>
                  {versements.map((v: any, i: number) => (
                    <tr key={v.id}>
                      <td>{i + 1}</td>
                      <td>{v.date ? new Date(v.date).toLocaleDateString('fr-FR') : '-'}</td>
                      <td><span className="badge badge-blue">{v.type || '-'}</span></td>
                      <td>{v.reference || '-'}</td>
                      <td style={{ textAlign: 'right', fontWeight: 600 }}>{formatMoney(v.montant || 0)}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr style={{ fontWeight: 700, background: '#f5f5f5' }}>
                    <td colSpan={4} style={{ textAlign: 'right' }}>Total</td>
                    <td style={{ textAlign: 'right' }}>{formatMoney(totalVersements)}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MesVersements;
